import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/membershipLevels', request)
}

export {get}
